import { observable, runInAction, toJS } from 'mobx';
import noop from 'lodash/noop';
import isObject from 'lodash/isObject';
import { RecordStatus, DownloadAllMode } from '../data-set/enum';
import defaultFeedback from '../data-set/FeedBack';
import { defaultValidationMessageFormatter, defaultValidationMessageReportFormatter, } from '../validator/ValidationMessageReportFormatter';
const defaultLookupCache = { maxAge: 1000 * 60 * 10, max: 100 };
const defaultStatus = { [RecordStatus.add]: 'add', [RecordStatus.update]: 'update', [RecordStatus.delete]: 'delete' };
const defaultFormatter = {
    jsonDate: 'YYYY-MM-DD HH:mm:ss',
    date: 'YYYY-MM-DD',
    dateTime: 'YYYY-MM-DD HH:mm:ss',
    time: 'HH:mm:ss',
    year: 'YYYY',
    month: 'YYYY-MM',
    week: 'GGGG-Wo',
};
const defaultAttachment = {
    defaultFileKey: 'file',
    defaultFileSize: 0,
    defaultChunkSize: 5 * 1024 * 1024,
    defaultChunkThreads: 3,
    downloadAllMode: DownloadAllMode.readOnly,
    getDownloadUrl({ attachment }) {
        return attachment.url;
    },
};
const defaultConfig = {
    lookupCache: defaultLookupCache,
    lookupUrl: code => `/common/code/${code}/`,
    lookupAxiosMethod: 'post',
    lovDefineUrl: code => `/sys/lov/lov_define?code=${code}`,
    lovQueryUrl: code => `/common/lov/dataset/${code}`,
    dataKey: 'rows',
    totalKey: 'total',
    countKey: 'needCountFlag',
    statusKey: '__status',
    tlsKey: '__tls',
    status: defaultStatus,
    feedback: defaultFeedback,
    formatter: defaultFormatter,
    attachment: defaultAttachment,
    confirm: (_message, _dataSet, _source) => Promise.resolve(true),
    validationMessageFormatter: defaultValidationMessageFormatter,
    validationMessageReportFormatter: defaultValidationMessageReportFormatter,
    xlsx: noop,
    useLookupBatch: noop,
    useLovDefineBatch: noop,
};
const defaultGlobalConfig = observable.map(defaultConfig);
const globalConfig = observable.map();
const baseMergeProps = ['transport', 'feedback', 'formatter', 'attachment'];
export function getConfig(key) {
    if (!globalConfig.has(key)) {
        return defaultGlobalConfig.get(key);
    }
    const custom = globalConfig.get(key);
    if (baseMergeProps.includes(key)) {
        return {
            ...defaultGlobalConfig.get(key),
            ...custom,
        };
    }
    return custom;
}
export function overwriteDefaultConfig(config, mergeProps = baseMergeProps) {
    runInAction(() => {
        Object.keys(config).forEach((key) => {
            const configKey = key;
            const value = config[configKey];
            if (mergeProps && mergeProps.includes(configKey) && isObject(value)) {
                defaultGlobalConfig.set(configKey, {
                    ...toJS(defaultGlobalConfig.get(configKey)),
                    ...value,
                });
            }
            else {
                defaultGlobalConfig.set(configKey, config[configKey]);
            }
        });
    });
}
export function overwriteConfigMergeProps(customMergeProps) {
    baseMergeProps.push(...customMergeProps);
}
export default function configure(config, mergeProps = baseMergeProps) {
    runInAction(() => {
        Object.keys(config).forEach((key) => {
            const configKey = key;
            const value = config[configKey];
            if (mergeProps && mergeProps.includes(configKey) && isObject(value)) {
                globalConfig.set(configKey, {
                    ...toJS(globalConfig.get(configKey)),
                    ...value,
                });
            }
            else {
                globalConfig.set(configKey, config[configKey]);
            }
        });
    });
}
